import type { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { catchError, throwError } from 'rxjs'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const token = localStorage.getItem('jwt') ?? undefined
    const router = inject(Router)
    const toastrService = inject(ToastrService)

    if (token) {
        req = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
        })
    }

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            if ([401, 403].includes(err.status)) {
                toastrService.error('Вы не авторизованы')
                router.navigate(['/auth'])
            }
            return throwError(() => err)
        })
    )
}
